import React, { FC, useState } from 'react';
import { EnvKey, MapNavigationPill } from '@/src/components/UI/HouseDetail/MapViewSection';
import MapPageProps from '@/src/components/UI/MapContainerType';
import Link from 'next/link';
import { Stack } from '@chakra-ui/react';
import Image from 'next/image';
import dynamic from 'next/dynamic';

const MapView = dynamic(() => import('@/src/components/UI/Map/MapView'), {
  ssr: false,
});

const MapContainer: FC<MapPageProps> = ({ detailData }) => {
  const [selectedPill, setSelectedPill] = useState<EnvKey>('traffic');
  if (
    !detailData.location_latitude ||
    !detailData.location_longitude ||
    isNaN(parseFloat(detailData!.location_latitude!)) ||
    isNaN(parseFloat(detailData!.location_longitude!))
  )
    return null;
  return (
    <div className={`h-screen w-screen`}>
      <MapView
        center={{
          lat: parseFloat(detailData!.location_latitude!),
          lng: parseFloat(detailData!.location_longitude!),
        }}
        //@ts-ignore
        markers={detailData[`traffic_env_${selectedPill}`]}
      />
      <Link passHref href={`/buy/${detailData.sid}/street`}>
        <Stack w={'15%'} position={'absolute'} right={15} bottom={'80px'}>
          <Image width={360} height={270} layout={'responsive'} src={'/street.png'} priority />
        </Stack>
      </Link>
      <div className={' fixed top-0 left-0 w-screen bg-white'}>
        <MapNavigationPill
          country={detailData.country!}
          selectedPill={selectedPill}
          onSelect={(value) => setSelectedPill(value)}
        />
      </div>
    </div>
  );
};
export default MapContainer;
